import markUrl from '../assets/logo-mark.png'
import lockupUrl from '../assets/logo-full.png'

/**
 * The shop mark: the gold W with the flower growing through it.
 *
 * A bitmap rather than inline SVG, because the mark is a piece of artwork with
 * a metallic gradient down every stroke - drawing that by hand would be a worse
 * copy of something that already exists. It also survives the trip into a PDF
 * better than the old inline drawing did: html2canvas serialises an SVG away
 * from the page and loses anything inherited from it, while an image is simply
 * an image.
 *
 * Gold is made to sit on something dark. On the letterhead and the login plate
 * it has that; anywhere pale, it reads as a faint smudge - so those are the
 * only two places it is used.
 */
export function FlowerMark({ size = 28 }: { size?: number }) {
  return (
    <img
      src={markUrl}
      alt=""
      aria-hidden="true"
      /* 288x256 in the source; height drives the size, width follows it. */
      height={size}
      width={Math.round(size * 1.125)}
      draggable={false}
      style={{ display: 'block', objectFit: 'contain' }}
    />
  )
}

/**
 * The full stacked lockup - mark, WAJID, FLOWER - for the one screen that is
 * nothing but the shop introducing itself.
 */
export function ShopLockup({ width = 300 }: { width?: number }) {
  return (
    <img
      className="lockup"
      src={lockupUrl}
      alt="WAJID FLOWER"
      /* 760x626 in the source. */
      width={width}
      height={Math.round(width * (626 / 760))}
      draggable={false}
    />
  )
}
